import { gql } from 'apollo-angular';
import { LicenceInfo } from '../../entities/licenceInfo/licenceInfo';

export const CREATE_LICENCE_MUTATION = gql`
mutation createLicenceRequests($input: [TenantLicenceRequestInput]) {
  createLicenceRequests(input: $input) {
    id
  }
}
`;

export const RECALCULATE_LICENCES_MUTATION = gql`
mutation recalculateAssingedLicences($id: UUID) {
  recalculateAssingedLicences(id: $id) {
    id
  }
}
`;

export const GET_LICENCE_INFOS_QUERY = gql`
query groups{
  getLicenceInfos {
    type
    open
    assigned
    available
    assignable
  }
}
`;

export interface GetLicenceInfosResponse {
  getLicenceInfos: LicenceInfo[];
  loading: boolean;
}